module.exports = __webpack_public_path__ + "img/Armenia.caab5fe0.png";